module.exports = __webpack_public_path__ + "static/img/1.1d9083f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/1/sp/1.png
// module id = st+C
// module chunks = 0